export const downloadDocumentBlob = (blob: Blob, name: string) => {
  const navigator = window.navigator as Navigator & { msSaveOrOpenBlob?: (blob: Blob, name: string) => void };
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, name);
    return;
  }
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  document.body.appendChild(anchor);
  try {
    anchor.href = url;
    anchor.download = name;
    anchor.click();
  } finally {
    URL.revokeObjectURL(url);
    anchor.remove();
  }
};

export const navigateNativeDocument = (url: string) => {
  window.location.href = url;
};
